import { combineEpics } from 'redux-observable';

import fetchEmployeeProfileEpic from './epics/fetchEmployeeProfile';

export default combineEpics(fetchEmployeeProfileEpic);
